import { render, staticRenderFns } from "./ConfirmationModalDefaultTasks.vue?vue&type=template&id=4c147344&"
import script from "./ConfirmationModalDefaultTasks.vue?vue&type=script&lang=js&"
export * from "./ConfirmationModalDefaultTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports